import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import './header.css';
import { links } from '../../json/headerLinks';

const Header = () => {
  const [overlay, setOverlay] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [activeNestedSubmenu, setActiveNestedSubmenu] = useState(null);

  const handleMouseEnter = (submenu) => {
    setActiveSubmenu(submenu);
  };

  const handleMouseLeave = () => {
    setActiveSubmenu(null);
    setActiveNestedSubmenu(null);
  };

  const hideMenu = () => {
    const div = document.getElementById('navbarNav');
    div.classList.remove('show');
    setOverlay(false);
  };

  return (
    <>
      {overlay ? (
        <div
          onClick={() => {
            setOverlay(!overlay);
          }}
          className='overlay-menu'
          data-bs-toggle='collapse'
          data-bs-target='#navbarNav'
          aria-controls='navbarNav'
        ></div>
      ) : null}
      <div id='header'>
        <nav className={`navbar navbar-expand-lg navbar-light bg-gob ${isMobile ? 'mobile-menu' : ''}`}>
          <div className='container-fluid'>
            <Link className='nav-link active' aria-current='page' to='/'>
              {isMobile ? (
                <img className='logo-menu' src='assets/imgs/movilidaddorado.png' alt='' />
              ) : (
                <span>SECRETARÍA DE MOVILIDAD Y TRANSPORTE</span>
              )}
            </Link>
            <span
              className='navbar-toggler'
              type='button'
              data-bs-toggle='collapse'
              data-bs-target='#navbarNav'
              aria-controls='navbarNav'
              aria-expanded='false'
              aria-label='Toggle navigation'
              onClick={() => {
                setOverlay(true);
              }}
              style={{ color: 'white' }}
              viewBox='0 0 32 32'
            >
              MENÚ
            </span>
            <div className={`collapse navbar-collapse second-navbar-gob ${isMobile ? 'mobile-collapse' : ''}`} id='navbarNav'>
              <ul
                id='menu-list'
                className='navbar-nav'
                onClick={() => {
                  setActiveSubmenu(null);
                  hideMenu();
                }}
              >
                <li className='nav-item'>
                  <Link to='/' className='nav-link'>
                    Inicio
                  </Link>
                </li>
                {links.map((item, index) => (
                  <li
                    key={index}
                    className='nav-item dropdown'
                    onMouseEnter={() => handleMouseEnter(item.nombre)}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Link
                      to={item.link}
                      className='nav-link'
                      onClick={() => {
                        setActiveSubmenu(null);
                        setActiveNestedSubmenu(null);
                      }}
                    >
                      {item.nombre}
                    </Link>
                    {item.submenu && item.submenu.length > 0 && (
                      <ol className={`dropdown-menu ${activeSubmenu === item.nombre ? 'show' : ''}`} aria-labelledby='navbarDropdownMenuLink'>
                        {item.submenu.map((submenuItem, submenuIndex) => {
                          const hasNested = submenuItem.submenu && submenuItem.submenu.length > 0;
                          const nestedKey = `${item.nombre}-${submenuIndex}`;

                          return (
                            <li key={submenuIndex} style={{ position: 'relative' }}>
                              {hasNested ? (
                                <button
                                  type='button'
                                  className='dropdown-item'
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setActiveNestedSubmenu(activeNestedSubmenu === nestedKey ? null : nestedKey);
                                  }}
                                >
                                  {submenuItem.subMenuNombre}
                                </button>
                              ) : (
                                <Link className='dropdown-item' to={submenuItem.subMenuUrl}>
                                  {submenuItem.subMenuNombre}
                                </Link>
                              )}

                              {hasNested && (
                                <ol
                                  className={`dropdown-menu ${activeNestedSubmenu === nestedKey ? 'show' : ''}`}
                                  style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: '100%',
                                    marginLeft: '0.25rem',
                                    minWidth: '18rem',
                                  }}
                                >
                                  {submenuItem.submenu.map((childItem, childIndex) => (
                                    <li key={childIndex}>
                                      <Link className='dropdown-item' to={childItem.subMenuUrl}>
                                        {childItem.subMenuNombre}
                                      </Link>
                                    </li>
                                  ))}
                                </ol>
                              )}
                            </li>
                          );
                        })}
                      </ol>
                    )}
                    <span className={`triangle ${activeSubmenu === item.nombre ? 'show' : ''}`} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
